import axios from 'axios'
import { signInSuccess, signOutSuccess } from 'store/slices/identitySlice'
import store from '../store'
import { AUTH_TOKEN } from 'constants/AuthConstant'
import jwtDecode from 'jwt-decode'
import { Mutex } from 'async-mutex'
import { notification } from 'components/util-components/FeedbackProvider'
import IdentityService from 'services/IdentityService'

const unauthorizedCode = [401, 403]

const service = axios.create({
  timeout: 60000,
})

// Config
const TOKEN_PAYLOAD_KEY = 'authorization'

const mutex = new Mutex()
// API Request interceptor
service.interceptors.request.use(
  async config => {
    let jwtToken = localStorage.getItem(AUTH_TOKEN) || null
    if (jwtToken) {
      var decoded = jwtDecode(jwtToken)
      var current_time = (Date.now() + 5 * 1000) / 1000
      if (decoded.exp < current_time) {
        const release = await mutex.acquire()
        if (localStorage.getItem(AUTH_TOKEN) === jwtToken) {
          try {
            const response = await IdentityService.refreshToken()

            if (response.status === 200) {
              jwtToken = response.data.access_token
              store.dispatch(signInSuccess(jwtToken))
              localStorage.setItem(AUTH_TOKEN, jwtToken)
            }
          } catch (error) {
            console.log(error)
          }
        } else {
          jwtToken = localStorage.getItem(AUTH_TOKEN) || null
        }
        release()
      }

      config.headers[TOKEN_PAYLOAD_KEY] = `Bearer ${jwtToken}`
    }

    return config
  },
  error => {
    // notification.error({
    //   message: 'Error',
    // })

    Promise.reject(error)
  }
)

// API respone interceptor
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    let notificationParam = {
      message: '',
    }

    // Remove token and redirect
    if (unauthorizedCode.includes(error.response.status)) {
      localStorage.removeItem(AUTH_TOKEN)
      store.dispatch(signOutSuccess())
    }

    if (error.response.status === 404) {
      notificationParam.message = 'Not Found'
    }

    if (error.response.status === 500) {
      notificationParam.message = 'Internal Server Error'
    }

    if (error.response.status === 508) {
      notificationParam.message = 'Time Out'
    }

    if (notificationParam.message) {
      notification.open({
        type: 'error',
        key: 'interceptor',
        ...notificationParam,
      })
    }

    return Promise.reject(error)
  }
)

export default service
